import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { toast } from "react-toastify";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import Pagination from "../../../Components/Common/Pagination";

import {
  addUnranked,
  deleteUnranked,
  getUnranked,
  updateUnranked,
} from "../../../slices/6-unranked/thunk";
import { getCategories } from "../../../slices/2-category/thunk";

const RoomsTable = () => {
  const [modal_list, setmodal_list] = useState(false);
  const dispatch = useDispatch();
  const [editModal, setEditModal] = useState(false);
  const [name, setName] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const [currentRoom, setCurrentRoom] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [icon, setIcon] = useState("ri-folder-line");
  const [items, setItems] = useState([]);

  const [maxPlayers, setMaxPlayers] = useState(null);
  const [questionCount, setQuestionCount] = useState(null);
  const [timePerQuestionSec, setTimePerQuestionSec] = useState(null);
  const [questionType, setQuestionType] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const { unranked, loading, error, totalPages } = useSelector(
    (state) => state.Unranked,
  );
  const { categories } = useSelector((state) => state.Categories);

  const [page, setPage] = useState(1);
  const limit = 10;

  useEffect(() => {
    dispatch(getUnranked({ page, limit }));
    dispatch(getCategories({ page, limit: 100 }));
  }, [dispatch, page]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const data = {
      name,
      // categoryId: selectedCategory,
      questionType,
      maxPlayers,
      questionCount,
      timePerQuestionSec,
      isPublic: true,
    };
    // console.log(data);
    dispatch(addUnranked(data))
      .unwrap()
      .then(() => {
        setmodal_list(false);

        // reset
        setName("");
        setSelectedCategory(null);
        setQuestionType(null);
        setMaxPlayers(null);
        setQuestionCount(null);
        setTimePerQuestionSec(null);

        dispatch(getUnranked({ page, limit }));
      });
  };

  const handleDelete = (id) => {
    setSelectedUserId(id);
    setDeleteModal(true);
  };

  const confirmDelete = () => {
    dispatch(deleteUnranked({ id: selectedUserId }))
      .unwrap()
      .then(() => {
        setDeleteModal(false);
        setSelectedUserId(null);
        dispatch(getUnranked({ page, limit }));
      });
  };

  const handleEdit = (item) => {
    setCurrentRoom(item);

    setName(item.name);
    setSelectedCategory(item.category?._id);
    setQuestionType(item.questionType);
    setMaxPlayers(item.maxPlayers);
    setQuestionCount(item.questionCount);
    setTimePerQuestionSec(item.timePerQuestionSec);

    setEditModal(true);
  };

  const handleEditSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const data = {
      name,
      categoryId: selectedCategory,
      questionType,
      maxPlayers,
      questionCount,
      timePerQuestionSec,
      isPublic: true,
    };

    dispatch(updateUnranked({ id: currentRoom._id, data }))
      .unwrap()
      .then(() => {
        setEditModal(false);
        dispatch(getUnranked({ page, limit }));
      });
  };

  const tog_list = () => {
    setmodal_list(!modal_list);
  };

  document.title = "Rooms";

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchTerm?.length >= 3 || searchTerm?.length === 0) {
        dispatch(getUnranked({ page, limit, search: searchTerm }));
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [dispatch, page, searchTerm]);

  useEffect(() => {
    setItems(unranked);
  }, [unranked]);

  const togglePause = (id) => {
    setItems((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, isPaused: !item.isPaused } : item,
      ),
    );
  };

  const toggleVisibility = (id) => {
    setItems((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, isHidden: !item.isHidden } : item,
      ),
    );
  };

  const validateForm = () => {
    if (!name.trim()) {
      toast.error("اسم مسابقة مطلوب");
      return false;
    }

    // if (!selectedCategory) {
    //   toast.error("اختار التصنيف");
    //   return false;
    // }

    if (!questionType) {
      toast.error("اختار نوع السؤال");
      return false;
    }

    if (!maxPlayers) {
      toast.error("اختار عدد اللاعبين");
      return false;
    }

    if (!questionCount) {
      toast.error("اختار عدد الأسئلة");
      return false;
    }

    if (!timePerQuestionSec) {
      toast.error("اختار وقت السؤال");
      return false;
    }

    return true;
  };

  // console.log(selectedUserId);
  // console.log(unranked);
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="إدارة مسابقات الغرف" />
          <Row>
            <Col lg={12}>
              <Card style={{ borderRadius: "16px" }}>
                <CardBody>
                  <div className="listjs-table" id="tagsList">
                    <Row className="g-4 mb-3">
                      <Col className="col-sm">
                        <div className="d-flex justify-content-sm-start">
                          <div className="search-box ms-2">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="بحث..."
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <i className="ri-search-line search-icon"></i>
                          </div>
                        </div>
                      </Col>

                      <Col className="col-sm-auto">
                        <div>
                          <Button
                            color="success"
                            className="add-btn me-1 rounded-3"
                            onClick={() => tog_list()}
                            id="create-btn"
                          >
                            <i className="ri-add-line align-bottom me-1"></i>{" "}
                            إضافة
                          </Button>
                        </div>
                      </Col>
                    </Row>
                    <div className="table-responsive table-card mt-3 mb-1">
                      <table
                        className="table align-middle table-nowrap"
                        id="customerTable"
                      >
                        <thead className="table-light text-center">
                          <tr>
                            <th>رقم</th>
                            <th>اسم المسابقة</th>
                            <th>صاحب المسابقة</th>
                            <th>عدد الأسئلة</th>
                            <th>الكود</th>
                            <th>الحالة</th>
                            <th>إجراءات</th>
                          </tr>
                        </thead>
                        <tbody className="list form-check-all  text-center">
                          {unranked && unranked?.length > 0 ? (
                            unranked?.map((item, index) => (
                              <tr key={item.id} className="fs-5">
                                <td className="id" style={{ display: "none" }}>
                                  <Link
                                    to="#"
                                    className="fw-medium link-primary"
                                  >
                                    {item._id}
                                  </Link>
                                </td>

                                <td className="index">{index + 1}</td>
                                <td className="name">{item.name}</td>
                                <td className="coins">{item.host?.fullName}</td>
                                <td className="coins">{item.questionCount}</td>
                                <td className="coins">{item.code}</td>
                                <td>
                                  <span
                                    className={`badge rounded-pill ${
                                      item.status === "finished"
                                        ? "bg-danger"
                                        : "bg-success"
                                    }`}
                                  >
                                    {item.status}
                                  </span>
                                </td>
                                <td>
                                  <div className="d-flex gap-2 justify-content-center">
                                    {/* Pause / Play */}
                                    {/* <div>
                                      <button
                                        className="btn btn-sm"
                                        style={{
                                          padding: "0px",
                                          background: "transparent",
                                          border: "none",
                                        }}
                                        onClick={() => togglePause(item.id)}
                                      >
                                        <i
                                          className={
                                            item.isPaused
                                              ? "ri-play-line"
                                              : "ri-pause-line"
                                          }
                                          style={{
                                            color: "gray",
                                            fontSize: "20px",
                                          }}
                                        />
                                      </button>
                                    </div> */}

                                    {/* Edit */}
                                    <div>
                                      <button
                                        className="btn btn-sm"
                                        style={{
                                          padding: "0px",
                                          background: "transparent",
                                          border: "none",
                                        }}
                                        onClick={() => handleEdit(item)}
                                      >
                                        <i
                                          className="ri-edit-line"
                                          style={{
                                            color: "gray",
                                            fontSize: "20px",
                                          }}
                                        />
                                      </button>
                                    </div>

                                    {/* Delete */}
                                    <div>
                                      <button
                                        className="btn btn-sm"
                                        style={{
                                          padding: "0px",
                                          background: "transparent",
                                          border: "none",
                                        }}
                                        onClick={() => handleDelete(item._id)}
                                      >
                                        <i
                                          className="ri-delete-bin-line"
                                          style={{
                                            color: "#dc3545", // Bootstrap red
                                            fontSize: "20px",
                                          }}
                                        />
                                      </button>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7" className="text-center">
                                لا يوجد غرف
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    {/* Pagination */}
                    <div className="row g-0 text-center text-sm-start align-items-center mb-4">
                      <div className="col-sm-6"></div>
                      <div className="col-sm-6">
                        <Pagination
                          currentPage={page}
                          totalPages={totalPages}
                          onPageChange={(newPage) => {
                            setPage(newPage);
                            window.scrollTo({
                              top: 0,
                              behavior: "smooth",
                            });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Add Modal */}
      <Modal isOpen={modal_list} toggle={tog_list} centered size="md">
        <ModalHeader toggle={tog_list} className="border-0 pb-0">
          إنشاء مسابقة جديدة
        </ModalHeader>

        <form onSubmit={handleSubmit}>
          <ModalBody className="pt-2">
            <div className="mb-4 mt-4">
              <label className="form-label fw-semibold">اسم المسابقة</label>
              <input
                type="text"
                className="form-control rounded-3 py-2"
                placeholder="مثال: مسابقة الأبطال"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>

            {/* <div className="mb-4">
              <label className="form-label fw-semibold">التصنيف</label>
              <Select
                options={categories?.map((cat) => ({
                  value: cat._id,
                  label: cat.name,
                }))}
                placeholder=" اختر التصنيف المناسب"
                onChange={(e) => setSelectedCategory(e.value)}
              />
            </div> */}

            <div className="mb-4">
              <label className="form-label fw-semibold">نوع الأسئلة</label>
              <Select
                options={[
                  { value: "mcq", label: "اختار صح" },
                  { value: "player", label: "من أنا؟" },
                  { value: "career", label: "مسيرة النجم" },
                ]}
                placeholder="اختر النوع المناسب"
                onChange={(e) => setQuestionType(e.value)}
              />
            </div>

            <div className="mb-4">
              <label className="form-label fw-semibold">أقصى عدد للاعبين</label>
              <div className="d-flex justify-content-between flex-wrap">
                {[4, 8, 12, 16].map((num) => {
                  const isActive = maxPlayers === num;

                  return (
                    <button
                      key={num}
                      type="button"
                      onClick={() => setMaxPlayers(num)}
                      style={{
                        width: "23%",
                        border: "2px solid",
                        borderColor: isActive ? "#28a745" : "#ddd",
                        background: isActive ? "#f6fff8" : "#fff",
                        color: isActive ? "#28a745" : "#000",
                        padding: "10px",
                        borderRadius: "12px",
                        transition: "0.3s",
                        fontWeight: "500",
                        cursor: "pointer",
                      }}
                    >
                      {num}
                    </button>
                  );
                })}
              </div>
            </div>

            <div className="mb-4">
              <label className="form-label fw-semibold">عدد الأسئلة</label>
              <div className="d-flex justify-content-between flex-wrap">
                {[5, 10, 15, 20].map((num) => {
                  const isActive = questionCount === num;

                  return (
                    <button
                      key={num}
                      type="button"
                      onClick={() => setQuestionCount(num)}
                      style={{
                        width: "23%",
                        border: "2px solid",
                        borderColor: isActive ? "#28a745" : "#ddd",
                        background: isActive ? "#f6fff8" : "#fff",
                        color: isActive ? "#28a745" : "#000",
                        padding: "10px",
                        borderRadius: "12px",
                        transition: "0.3s",
                        fontWeight: "500",
                        cursor: "pointer",
                      }}
                    >
                      {num}
                    </button>
                  );
                })}
              </div>
            </div>

            <div className="mb-4">
              <label className="form-label fw-semibold">وقت السؤال (ث)</label>
              <div className="d-flex justify-content-between flex-wrap">
                {[20, 30, 40, 50].map((num) => {
                  const isActive = timePerQuestionSec === num;

                  return (
                    <button
                      key={num}
                      type="button"
                      onClick={() => setTimePerQuestionSec(num)}
                      style={{
                        width: "23%",
                        border: "2px solid",
                        borderColor: isActive ? "#28a745" : "#ddd",
                        background: isActive ? "#f6fff8" : "#fff",
                        color: isActive ? "#28a745" : "#000",
                        padding: "10px",
                        borderRadius: "12px",
                        transition: "0.3s",
                        fontWeight: "500",
                        cursor: "pointer",
                      }}
                    >
                      {num}
                    </button>
                  );
                })}
              </div>
            </div>
          </ModalBody>

          <ModalFooter className="border-0 justify-content-start">
            <button type="submit" className="btn btn-success px-4 rounded-3">
              التالي
            </button>
            <button
              type="button"
              className="btn btn-light px-4 rounded-3"
              onClick={tog_list}
            >
              إلغاء
            </button>
          </ModalFooter>
        </form>
      </Modal>

      {/* Edit Modal */}
      <Modal
        isOpen={editModal}
        toggle={() => setEditModal(false)}
        centered
        size="md"
      >
        <ModalHeader
          toggle={() => setEditModal(false)}
          className="border-0 pb-0"
        >
          تعديل مسابقة
        </ModalHeader>

        <form onSubmit={handleEditSubmit}>
          <ModalBody className="pt-2">
            {/* اسم المسابقة */}
            <div className="mb-4 mt-4">
              <label className="form-label fw-semibold">اسم المسابقة</label>
              <input
                type="text"
                className="form-control rounded-3 py-2"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            {/* التصنيف */}
            {/* <div className="mb-4">
              <label className="form-label fw-semibold">التصنيف</label>
              <Select
                options={categories?.map((cat) => ({
                  value: cat._id,
                  label: cat.name,
                }))}
                placeholder=" اختر التصنيف المناسب"
                value={categories
                  ?.map((cat) => ({
                    value: cat._id,
                    label: cat.name,
                  }))
                  .find((c) => c.value === selectedCategory)}
                onChange={(e) => setSelectedCategory(e.value)}
              />
            </div> */}

            {/* نوع السؤال */}
            <div className="mb-4">
              <label className="form-label fw-semibold">نوع الأسئلة</label>
              <Select
                options={[
                  { value: "mcq", label: "اختار صح" },
                  { value: "player", label: "من أنا؟" },
                  { value: "career", label: "مسيرة النجم" },
                ]}
                placeholder="اختر النوع المناسب"
                value={[
                  { value: "mcq", label: "اختار صح" },
                  { value: "player", label: "من أنا؟" },
                  { value: "career", label: "مسيرة النجم" },
                ].find((opt) => opt.value === questionType)}
                onChange={(e) => setQuestionType(e.value)}
              />
            </div>

            {/* أقصى عدد لاعبين */}
            <div className="mb-4">
              <label className="form-label fw-semibold">أقصى عدد للاعبين</label>
              <div className="d-flex justify-content-between flex-wrap">
                {[4, 8, 12, 16].map((num) => {
                  const isActive = maxPlayers === num;

                  return (
                    <button
                      key={num}
                      type="button"
                      onClick={() => setMaxPlayers(num)}
                      style={{
                        width: "23%",
                        border: "2px solid",
                        borderColor: isActive ? "#28a745" : "#ddd",
                        background: isActive ? "#f6fff8" : "#fff",
                        color: isActive ? "#28a745" : "#000",
                        padding: "10px",
                        borderRadius: "12px",
                        fontWeight: "500",
                        cursor: "pointer",
                      }}
                    >
                      {num}
                    </button>
                  );
                })}
              </div>
            </div>

            {/* عدد الأسئلة */}
            <div className="mb-4">
              <label className="form-label fw-semibold">عدد الأسئلة</label>
              <div className="d-flex justify-content-between flex-wrap">
                {[5, 10, 15, 20].map((num) => {
                  const isActive = questionCount === num;

                  return (
                    <button
                      key={num}
                      type="button"
                      onClick={() => setQuestionCount(num)}
                      style={{
                        width: "23%",
                        border: "2px solid",
                        borderColor: isActive ? "#28a745" : "#ddd",
                        background: isActive ? "#f6fff8" : "#fff",
                        color: isActive ? "#28a745" : "#000",
                        padding: "10px",
                        borderRadius: "12px",
                        fontWeight: "500",
                        cursor: "pointer",
                      }}
                    >
                      {num}
                    </button>
                  );
                })}
              </div>
            </div>

            {/* وقت السؤال */}
            <div className="mb-4">
              <label className="form-label fw-semibold">وقت السؤال (ث)</label>
              <div className="d-flex justify-content-between flex-wrap">
                {[20, 30, 40, 50].map((num) => {
                  const isActive = timePerQuestionSec === num;

                  return (
                    <button
                      key={num}
                      type="button"
                      onClick={() => setTimePerQuestionSec(num)}
                      style={{
                        width: "23%",
                        border: "2px solid",
                        borderColor: isActive ? "#28a745" : "#ddd",
                        background: isActive ? "#f6fff8" : "#fff",
                        color: isActive ? "#28a745" : "#000",
                        padding: "10px",
                        borderRadius: "12px",
                        fontWeight: "500",
                        cursor: "pointer",
                      }}
                    >
                      {num}
                    </button>
                  );
                })}
              </div>
            </div>
          </ModalBody>

          <ModalFooter className="border-0 justify-content-start">
            <button type="submit" className="btn btn-primary px-4 rounded-3">
              حفظ التعديلات
            </button>

            <button
              type="button"
              className="btn btn-light px-4 rounded-3"
              onClick={() => setEditModal(false)}
            >
              إلغاء
            </button>
          </ModalFooter>
        </form>
      </Modal>

      {/* Confirm Toggle Block Modal */}
      <Modal isOpen={deleteModal} toggle={() => setDeleteModal(false)} centered>
        <ModalHeader toggle={() => setDeleteModal(false)}>
          تأكيد الحذف
        </ModalHeader>

        <ModalBody className="text-center">
          <h5>هل أنت متأكد من حذف المسابقة؟</h5>
        </ModalBody>

        <ModalFooter>
          <Button color="light" onClick={() => setDeleteModal(false)}>
            إلغاء
          </Button>
          <Button color="danger" onClick={confirmDelete}>
            حذف
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default RoomsTable;
